<div class="center">
    <p>{{ ('Click the button below and follow the instructions to link {}' | translate).replace('{}', 'Stripe') }}</p>
    <button
            (click)="clickHandler(isLinked ? 'remove' : 'connect')"
            mat-stroked-button
    >
        {{ ( isLinked ? "Remove" : "Link Stripe" ) | translate }}
    </button>
</div>